import Nav from "../Nav";
import Head from "../Head";
import Swal from "sweetalert2";
import icono from "../../img/jacinto_de_agua_comun_6.jpg";
import Carousel from "../Carousel";

export const Jacinto = () => {
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  };

  const handleCompra = () => {
    let deviceType =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? "api"
        : "web";

    const whatsapp = `Hola *Revelados orgánicos* 🐌. Quiero encargar un fotolibro 🎞️📖!`;
    let linkCompra = `https://${deviceType}.whatsapp.com/send?phone=5493413779106&text=${whatsapp}`;
    window.open(linkCompra, "_blank");

    // Muestra el mensaje de agradecimiento
    Swal.fire({
      text: "Gracias por encargar tu librito!",
      iconHtml: `<img src="${icono}" alt="Icono personalizado" width="200"/>`,
      showConfirmButton: true,
      confirmButtonText: "Aceptar",
      customClass: {
        icon: "custom-icon-class",
      },
      confirmButtonClass: "btnSweet",
    });
  };

  return (
    <>
      <Head title="Proyecto - Jacinto de agua común" />
      <Nav titulo="Jacinto de agua común" link="/proyectos" />
      <section
        id="about_me"
        className="mb-5 animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <div className="container-fluid overflow-hidden">
          <div className="row marMob">
            <h3 className="text-center text-md-start fs-6">
              <i className="bi bi-droplet"></i> Fotolibro "Jacinto de agua
              común"
            </h3>
            <hr />
            <h3 className="text-end">
              “Corría el río en mi con sus ramajes. <br />
              Era yo un río en el anochecer, <br />
              Y suspiraban en mí los árboles <br />
              Y el sendero y las hierbas se apagaban en mí.
              <br />
              Me atravesaba un río, me atravesaba un río! <br />
              Juan L. Ortíz
            </h3>

            <div className="row mt-md-3 jacinto">
              <div className="col-md-6 img-fluid  p-md-4 p-1">
                <Carousel settings={settings}>
                  <img
                    src="../img/jacinto_de_agua_comun/fotolibro (3).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/jacinto_de_agua_comun/fotolibro (1).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/jacinto_de_agua_comun/fotolibro (4).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/jacinto_de_agua_comun/fotolibro (2).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                </Carousel>
              </div>
              <div className="p-md-4 p-1 col-md-6 text-center text-md-start">
                {/* <hr />
            <h3 className="text-center text-md-start fs-6">
            Jacinto de agua común
            </h3>
            <hr /> */}
                <p>
                  $18.000 / 1era Edición 2023.
                  <br /> <br />
                  Realizado con el apoyo del Ministerio de Cultura de Santa Fe.
                  Convocatoria Plan Fomento 2022.
                  <br /> <br />
                  Si tenés ganas de tenerlo escribinos!
                  <br /> <span className="ms-md-3">↘</span>
                </p>
                <div
                  onClick={handleCompra}
                  className="text-center text-md-start botonCompra mt-3 mb-3"
                >
                  Comprar <i className="bi bi-whatsapp"></i>
                </div>
              </div>
            </div>

            <iframe
              className="iframeJacinto"
              src={`https://www.youtube.com/embed/r-1ZYegFb7w`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>

            <div className="row jacinto">
              <p className="col-md-6 ">
                Jacinto de agua común es un proyecto de fotografía analógica sin
                uso de cámaras ni químicos industriales. Utilizamos cámaras
                estenopeicas y trabajamos sobre el desarrollo de reveladores
                fotográficos a base de plantas para fotografía blanco y negro.{" "}
              </p>
              <img
                src="../img/jacinto_de_agua_comun/jacinto_de_agua_comun_6.jpg"
                className="col-md-6  img-fluid"
                alt="Jacinto de agua común"
              />
            </div>
            <div className="row jacinto">
              <img
                src="../img/jacinto_de_agua_comun/jacinto_de_agua_comun_2.jpg"
                className="order-2 order-md-1 img-fluid col-md-6"
                alt="Jacinto de agua común"
              />
              <p className="order-1 order-md-2 col-md-6">
                Nuestra práctica incluye la situación de laboratorio foto-
                gráfico tradicional en cuarto oscuro y el uso de papeles
                fotosensibles que son revelados y fijados a partir de procesos
                alternativos propios aprovechando los componentes que poseen
                algunas plantas de la región litoral. En este caso los revelados
                confeccionados fueron a base de hojas de aguaribay y corteza de
                ceibo. Jacinto de agua común es el nombre con el que se conoce
                al camalote. Lo elegimos porque viaja a lo largo del río, y por
                ser elemento característico que se puede divisar fácilmente en
                la región litoral.
              </p>
            </div>

            <div className="row jacinto">
              <p className="col-md-6">
                Hoy en día la práctica fotográfica analógica ya no puede ser
                pensada alejada de los problemas ambientales. Por ese motivo no
                usamos agua potable para lavar nuestras copias ni para preparar
                las fórmulas porque no es el resultado meticu- loso, pulcro lo
                que nos interesa, sino que ponemos en valor los resultados
                estéti- cos y visuales propios de los materiales usados. De este
                modo cada elemento del entorno dejará su huella en la imagen.
              </p>

              <img
                src="../img/jacinto_de_agua_comun/jacinto_de_agua_comun_1.jpg"
                className="col-md-6 img-fluid "
                alt="Jacinto de agua común"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
